<template>
  <div class="qianDao">
    <Header
      :title="type == 0 ? '打卡' : '更新打卡'"
      type="0"
      :route="'/sxKq/KQ?list=' + params"
    ></Header>
    <div class="sub_succeed">
      <div class="map">
        <el-amap
          ref="map"
          :amap-manager="amapManager"
          :plugin="plugin"
          vid="amapDemo"
          class="amap-demo"
        >
        </el-amap>
      </div>
      <p>
        当前时间为
        <br />
        <span>{{ time.mc }}</span>
        <br />
        当前地点为
        <br />
        <span>{{ addr }}</span>
      </p>
    </div>
    <div class="sub_succeed_foot">
      <button class="back_btn" @click="daka()">
        {{ type == 0 ? "打卡" : "更新打卡" }}
      </button>
    </div>
  </div>
</template>

<script>
import { Api } from "../../../../utils/axios";
import { AMapManager } from "vue-amap";
let amapManager = new AMapManager();

export default {
  data() {
    let self = this;
    return {
      amapManager,
      plugin: [
        {
          pName: "Geolocation",
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          timeout: 10000, //超过10秒后停止定位，默认：5s
          buttonPosition: "RB", //定位按钮的停靠位置
          zoomToAccuracy: true, //定位成功后是否自动调整地图视野到定位点
          //   showMarker: false, //定位成功后在定位到的位置显示点标记，默认：true
          events: {
            init(o) {
              // o 是高德地图定位插件实例
              o.getCurrentPosition((status, result) => {
                console.log(status);
                console.log(result);
                if (status == "complete") {
                  self.complete(result);
                } else {
                  self.$toast.fail("定位失败！");
                }
              });
            }
          }
        }
      ],
      time: {},
      addr: "",
      type: "",
      params: {}
    };
  },
  created() {
    this.params = JSON.stringify(this.$route.query.params);
    this.type = this.$route.query.type;
    let date = new Date();
    this.time.mc =
      date.getFullYear() +
      "年" +
      (Number(date.getMonth()) + 1 < 10
        ? "0" + (Number(date.getMonth()) + 1)
        : Number(date.getMonth()) + 1) +
      "月" +
      (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) +
      "日 " +
      (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +
      "时" +
      (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      "分";

    this.time.dm =
      (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +
      ":" +
      (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes());
  },
  methods: {
    complete(GeolocationResult) {
      this.addr = GeolocationResult.formattedAddress;
    },
    async daka() {
      if (this.addr == "") {
        this.$toast.fail("暂未定位到地点，请重进打卡页面！");
        return;
      }
      let params = {
        rwfbid: this.$route.query.list.rwfbid,
        kqdkszsjid: this.$route.query.list.kqdkszsjid,
        kqdkszid: this.$route.query.list.kqdkszid,
        sj: this.time.dm,
        dd: this.addr
      };
      if (this.type == 1) {
        params.xskqid = this.$route.query.list.xskqid;
      }
      const res = await Api.sxdksave(params);
      if (res.code == "1") {
        this.$router.replace({
          path: "/sxKq/time",
          query: {
            list: {
              sj: this.time.mc,
              dd: this.addr
            },
            params: this.params,
            type: this.$route.query.type
          }
        });
      } else {
        return;
      }
    }
  }
};
</script>

<style lang="less">
.qianDao {
  .sub_succeed {
    padding: 0 40px;
    box-sizing: border-box;
    .map {
      height: 200px;
      width: 100%;
      margin-bottom: 20px;
    }
    .call {
      color: #757da3;
      font-size: 24px;
      line-height: 35px;
      margin-bottom: 10px;
    }
    p {
      color: #757da3;
      font-size: 16px;
      line-height: 26px;
      span {
        color: #757da3;
        font-size: 18px;
        font-weight: bold;
        word-break: break-all;
        display: block;
      }
    }
  }
  .sub_succeed .icon_succeed {
    width: 120px;
    height: 120px;
    background: url(../../../../../static/img/succeed.png) no-repeat center
      center;
    background-size: contain;
    margin: 30px auto;
  }
  .back_btn {
    width: 100%;
    height: 44px;
    background: rgba(116, 105, 248, 1);
    border-radius: 3px;
    color: @attendance-color-3;
    font-size: 16px;
  }
  .sub_succeed_foot {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    position: fixed;
    bottom: 20px;
  }
  .tips {
    width: 100%;
    text-align: center;
    font-size: 16px;
    color: @attendance-color-2;
    margin-top: -25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/sxKq/daka.vue